<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article
          id="post-2252"
          class="post-2252 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <div class="hc-contact">
              <div class="container">
                <div class="row tick-cont">
                  <div class="col-md-12 submit-form">
                    <div class="form-title">
                      <h1
                        class="logo"
                        style="margin: 0 auto; text-align: center"
                      >
                        <a
                          href="https://www.clearmeout.com/"
                          style="
                            display: block;
                            width: fit-content;
                            margin: auto;
                          "
                        >
                          <img
                            class="img-responsive"
                            src="/static/assets/images/logo.png"
                            alt="ClearMeOut"
                          />
                        </a>
                      </h1>
                      <h3 style="margin: 10px auto; text-align: center">
                        Select Customized Service Package
                      </h3>
                      <br />
                    </div>

                    <form class="wpcf7-form" @submit.prevent="submit" novalidate>
                      <div class="form-group">
                        <label for="exampleInputEmail1" style="position: relative;">
                          Package Type*
                        </label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="packageType"
                            name="packageType"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="images">Image</option>
                            <option value="video">Video</option>
                            <option value="audio">Audio</option>
                            <option value="text">Text</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group" style="margin: 30px 0;">
                        <label for="exampleInputEmail1" style="position: relative;">Number of Contents*
                          <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext">Number of Contents</span>
                            <span class="fa fa-question-circle"></span>
                          </span>
                        </label>
                        <div style="display: block; margin: 10px 0 30px; position: relative;">
                            <input
                              type="number"
                              class="form-control"
                              name="inputFiles"
                              id="exceptionalSources"
                              required="required"
                              v-model="imagesLimitSize"
                              v-on:change="onChangePackages"
                            />
                          </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail1" style="position: relative;">Upload Contents*
                          <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext">Total number of contents removed</span>
                            <span class="fa fa-question-circle"></span>
                          </span>
                        </label>
                        <div v-bind:key="index" v-for="(item, index) in clientInputImagesVideos" style="display: block; margin: 10px 0 30px; position: relative;">
                            <input
                              type="file"
                              class="form-control"
                              v-on:change="onChangeInputImagesVideos($event, index)"
                              name="inputFiles"
                              id="clientInputImagesVideos"
                              accept=".jpg,.png,.mp4,.mov"
                              required=""
                            />
                            <button
                              type="button"
                              v-if="(clientInputImagesVideos.length - 1) == index && `${(clientInputImagesVideos.length)}` !== `${imagesLimitSize}`"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientInputImagesVideos"
                            >
                              +
                            </button>
                            <p style="display: block; position: absolute; font-size: 12px;color: red;" v-if="item.error">Please select {{packageType == 'images' ? "image" : "video"}} </p>
                          </div>
                      </div>
                      <div class="form-group" style="margin-top: 30px">
                        <label
                          for="exampleInputEmail1"
                          style="position: relative"
                          >Removal Time*
                          <span class="tooltip" style="display: contents">
                            <span class="tooltiptext" v-if="packageType == 'images'"
                              >Actual number of days/hours taken for image
                              removal</span
                            >
                            <span class="tooltiptext" v-if="packageType == 'video'"
                              >Actual number of days/hours taken for video
                              removal</span
                            >
                            <span class="tooltiptext" v-if="packageType == 'audio'"
                              >Actual number of days/hours taken for audio
                              removal</span
                            >
                            <span class="tooltiptext" v-if="packageType == 'word'"
                              >Actual number of days/hours taken for word
                              removal</span
                            >
                            <span class="fa fa-question-circle"></span>
                          </span>
                        </label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="customPackageImagesValidDays"
                            name="customPackageImagesValidDays"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="days_21">21 days</option>
                            <option value="days_14">14 days</option>
                            <option value="days_7">7 days</option>
                            <option value="hours_48">48 hours</option>
                          </select></span
                        >
                      </div>
                      <div class="form-group" style="margin-top: 30px">
                        <label
                          for="exampleInputEmail1"
                          style="position: relative"
                          >Offenders Location*
                          <span class="tooltip" style="display: contents">
                            <span class="tooltiptext"
                              >Detects and reveals the first location or
                              multiple locations where offender was
                              operating</span
                            >
                            <span class="fa fa-question-circle"></span>
                          </span>
                        </label>
                        <span
                          class="wpcf7-form-control-wrap select-options"
                          style="display: block; width: 100%"
                          ><select
                            v-model="imageBasicOffendersLocation"
                            name="packageType"
                            class="wpcf7-form-control wpcf7-select wpcf7-validates-as-required"
                            aria-required="true"
                            aria-invalid="false"
                            required
                            style="background: white; width: 100%"
                          >
                            <option value="0">No</option>
                            <option value="1">
                              Yes
                            </option>
                          </select></span
                        >
                      </div>
                      <div class="form-group" style="margin: 30px 0;">
                        <label for="exampleInputEmail1" style="position: relative;">Exceptional Source*
                          <span class="tooltip" style="display: contents;">
                            <span class="tooltiptext">Exceptionl sources</span>
                            <span class="fa fa-question-circle"></span>
                          </span>
                        </label>
                        <div v-bind:key="index" v-for="(item, index) in exceptionalSources" style="display: block; margin: 10px 0 30px; position: relative;">
                            <input
                              type="text"
                              class="form-control"
                              name="inputFiles"
                              id="exceptionalSources"
                              required="required"
                            />
                            <button
                              type="button"
                              v-if="(exceptionalSources.length - 1) == index && `${exceptionalSources.length}` !== `${exceptionalSourcesLimit}`"
                              style="position: absolute; top: calc((100% - 25px) / 2); right: -30px; height: 25px;"
                              v-on:click="onAddClientAddExceptionalSources"
                            >
                              +
                            </button>
                          </div>
                          <input
                              type="file"
                              class="form-control"
                              name="inputFiles"
                              id="clientInputImagesVideos"
                              accept=".jpg,.png,.mp4,.mov"
                              required=""
                            />
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick1" name="tick1" v-model="agree1">
                            <label for="tick1">I am over 18 years old.</label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick2" name="tick2" v-model="agree2">
                            <label for="tick2">The content is my own personal or belongs to a person whom I am representing with legal authority.</label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick3" name="tick3" v-model="agree3">
                            <label for="tick3">This personal content does not require any legal clearance for removal. </label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick4" name="tick4" v-model="agree3">
                            <label for="tick4">This content is not in any commercial product.</label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick5" name="tick5" v-model="agree3">
                            <label for="tick5">I am or the person I am representing is not a Celebrity nor VIP, or do/does not have followers over 25,000 in any social media network.</label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick6" name="tick6" v-model="agree3">
                            <label for="tick6">This is not a business related content.</label>
                          </div>
                          <div class="col-sm-12 tick-row">
                            <input type="checkbox" id="tick8" name="tick8" v-model="agree8">
                            <label for="tick4">I confirm that I have read, consent and agree to “Clear Me Out’s” <a href="https://www.clearmeout.com/terms-of-service">Terms of Service</a> and <a href="https://www.clearmeout.com/privacy-policy">Privacy Policy</a>.</label>
                          </div>
                        </div>
                      </div>
                      <div class="error" v-if="allTermsRequiredError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold;text-align: center;"
                        >
                          Please agree to all terms and conditions
                        </p>
                      </div>
                      <div class="error" v-if="customFieldRequiredError">
                        <p
                          style="font-size: 14px; color: red; font-weight: bold;text-align: center;"
                        >
                          Please fill all details
                        </p>
                      </div>
                      <div>
                        <button v-on:click="submitRegistration" type="button" class="btn btn-primary check-btn" style="display: block;margin: 0 auto;border-radius: 10px;">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
          </div>
          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";

export default {
  name: "support_track",
  data() {
    return {
      msg: "Clear Me Out - Support",
      userType: "MySelf",
      ticketNumber: "",
      emailRequiredError: false,
      ticketNumberRequiredError: false,
      emailError: false,
      selectedPackage: "basic",
      dateOfBirth: new Date(),
      country: "Sri Lanka",
      clientInputLegalDocsLimit: 10,
      exceptionalSourcesLimit: 10,
      clientInputSignatureLimit: 2,
      gender: "",
      packageType: "images",
      imageVideosAdditionalFiles: [],
      clientInputImagesVideos: [{file: ""}],
      clientInputSignature: [{file: ""}],
      exceptionalSources: [{file: ""}],
      packages: this.$store.state.packages,
      imageBasicAdditionalCalculated: 0,
      selectedAdditionalImageVideoSize: 0,
      imageBasic48Hours: 0,
      imageBasicValidated: false,
      imageBasicOffendersLocation: 0,
      imageBasicAdditionalImages: 0,
      imageBasicSelectedTotal: 0,
      imageStandardAdditionalCalculated: 0,
      imageStandard48Hours: 0,
      imageStandardValidated: false,
      imageStandardOffendersLocation: 0,
      imageStandardAdditionalImages: 0,
      imageStandardSelectedTotal: 0,
      imagePremiumAdditionalCalculated: 0,
      imagePremium48Hours: 0,
      imagePremiumValidated: false,
      imagePremiumOffendersLocation: 0,
      imagePremiumAdditionalImages: 0,
      imagePremiumSelectedTotal: 0,
      videoBasicAdditionalCalculated: 0,
      videoBasic48Hours: 0,
      videoBasicValidated: false,
      videoBasicOffendersLocation: 0,
      videoBasicAdditionalVideo: 0,
      videoBasicSelectedTotal: 0,
      videoStandard48Hours: 0,
      videoStandardAdditionalCalculated: 0,
      videoStandardValidated: false,
      videoStandardOffendersLocation: 0,
      videoStandardAdditionalVideo: 0,
      videoStandardSelectedTotal: 0,
      videoPremiumAdditionalCalculated: 0,
      videoPremium48Hours: 0,
      videoPremiumValidated: false,
      videoPremiumOffendersLocation: 0,
      videoPremiumAdditionalVideo: 0,
      imageVideoTotalFeeCalculate: 0,
      imageVideoCardFeeCalculate: 0,
    };
  },
  components: {
    datetime: Datetime,
  },
  computed: {
    cardFee: function () {
        return `${parseFloat(this.packages[this.packageType].cardCommission * 100).toFixed(1)}%`;
    },
   imagesValidDays: function() {
      return this.packages[this.packageType][this.selectedPackage].valid_days;
    },
   images48Hours: function() {
      return this.packages[this.packageType][this.selectedPackage].hosted_48_hours;
    },
   imagesOffendersLocation: function() {
      return this.packages[this.packageType][this.selectedPackage].hosted_offenders;
    },
   additionalImagesLimitSize: function() {
      return this.packages[this.packageType][this.selectedPackage].additional_max_images;
    },
    // imagesLimitSize: function() {
    //   return this.packages[this.packageType][this.selectedPackage].base_images_limit;
    // },
    imageBasicDisabled: function () {
      return this.imageBasicValidated ? "" : "disabled";
    },
    imageBasicDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imageBasicValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imageStandardDisabled: function () {
      return this.imageStandardValidated ? "" : "disabled";
    },
    imageStandardDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imageStandardValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imagePremiumDisabled: function () {
      return this.imagePremiumValidated ? "" : "disabled";
    },
    imagePremiumDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.imagePremiumValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    imageVideoCalculate: function () {
      const selectedPackage = this.packages[this.packageType][this.selectedPackage];
      const { packages, maxPackageLimit } = this.$store.state;
      const { base, additional_images, hosted_48_hours, hosted_offenders } = selectedPackage || {};
      let totalCalculated = base;

      if(this.imageStandard48Hours !== null && parseInt(this.imageStandard48Hours) == 1) {
        totalCalculated += parseFloat(hosted_48_hours);
      }
      
      if(this.imageBasicOffendersLocation !== null && parseInt(this.imageBasicOffendersLocation) == 1) {
        totalCalculated += parseFloat(hosted_offenders);
      }

      if(this.imageStandardAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageStandardAdditionalImages) * additional_images;
        console.log("imagesCost", imagesCost);
        // this.imageBasicAdditionalCalculated = imagesCost;
        totalCalculated += imagesCost;

        if(parseInt(this.imageStandard48Hours) === 1) {
          totalCalculated += (imagesCost * this.packages[this.packageType].commission);
        }
      }

      if(totalCalculated > maxPackageLimit) {
        this.imageBasicValidated = false;
      } else {
        this.imageBasicValidated = true;
      }

      this.imageBasicSelectedTotal = totalCalculated;

      this.imageVideoCardFeeCalculate = parseFloat(totalCalculated * this.packages[this.packageType].cardCommission).toFixed(2);
      this.imageVideoTotalFeeCalculate = parseFloat(parseFloat(totalCalculated) + parseFloat(this.imageVideoCardFeeCalculate)).toFixed(2);

      return parseFloat(totalCalculated).toFixed(2);
    },
    imageBasicCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { basic } = images || {}; 
      const { base, additional_images } = basic || {};
      let totalCalculated = base;

      if(this.imageBasic48Hours !== null) {
        totalCalculated += parseFloat(this.imageBasic48Hours);
      }
      
      if(this.imageBasicOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imageBasicOffendersLocation);
      }

      if(this.imageBasicAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageBasicAdditionalImages) * additional_images;
        this.imageBasicAdditionalCalculated = imagesCost;
        totalCalculated += imagesCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imageBasicValidated = false;
      } else {
        this.imageBasicValidated = true;
      }

      this.imageBasicSelectedTotal = totalCalculated;

      return totalCalculated;
    },
    additionalImageVideosCalculate: function () {
      const commission = this.packages[this.packageType].commission;
      const { additional_images } = this.packages[this.packageType][this.selectedPackage] || {};
      let totalCalculated = 0;

      if(this.imageStandardAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageStandardAdditionalImages) * additional_images;
        this.imageStandardAdditionalCalculated = imagesCost;
        totalCalculated = imagesCost;
      }

      if(this.imageStandard48Hours && parseInt(this.imageStandard48Hours) === 1) {
        totalCalculated += (totalCalculated * commission);
      }

      return totalCalculated;
    },
    imageStandardCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { standard } = images || {}; 
      const { base, additional_images } = standard || {};
      let totalCalculated = base;
      
      if(this.imageStandard48Hours !== null) {
        totalCalculated += parseFloat(this.imageStandard48Hours);
      }
      
      if(this.imageStandardOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imageStandardOffendersLocation);
      }

      if(this.imageStandardAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imageStandardAdditionalImages) * additional_images;
        this.imageStandardAdditionalCalculated = imagesCost;
        totalCalculated += imagesCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imageStandardValidated = false;
      } else {
        this.imageStandardValidated = true;
      }

      this.imageStandardSelectedTotal = totalCalculated;

      return totalCalculated;
    },
    imagePremiumCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { images } = packages || {}; 
      const { premium } = images || {}; 
      const { base, additional_images } = premium || {};
      let totalCalculated = base;

      if(this.imagePremium48Hours !== null) {
        totalCalculated += parseFloat(this.imagePremium48Hours);
      }
      
      if(this.imagePremiumOffendersLocation !== null) {
        totalCalculated += parseFloat(this.imagePremiumOffendersLocation);
      }

      if(this.imagePremiumAdditionalImages !== null) {
        const imagesCost = parseFloat(this.imagePremiumAdditionalImages) * additional_images;
        this.imagePremiumAdditionalCalculated = imagesCost;
        totalCalculated += imagesCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.imagePremiumValidated = false;
      } else {
        this.imagePremiumValidated = true;
      }

      this.imagePremiumSelectedTotal = totalCalculated;

      return totalCalculated;
    },
    videoBasicDisabled: function () {
      return this.videoBasicValidated ? "" : "disabled";
    },
    videoBasicDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoBasicValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoStandardDisabled: function () {
      return this.videoStandardValidated ? "" : "disabled";
    },
    videoStandardDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoStandardValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoPremiumDisabled: function () {
      return this.videoPremiumValidated ? "" : "disabled";
    },
    videoPremiumDisabledReason: function () {
      const { maxPackageLimit } = this.$store.state;

      return this.videoPremiumValidated ? "" : `$${maxPackageLimit} Limit Exceeded`;
    },
    videoBasicCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { basic } = video || {}; 
      const { base, additional_videos } = basic || {};
      let totalCalculated = base;

      if(this.videoBasic48Hours !== null) {
        totalCalculated += parseFloat(this.videoBasic48Hours);
      }
      
      if(this.videoBasicOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoBasicOffendersLocation);
      }

      if(this.videoBasicAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoBasicAdditionalVideo) * additional_videos;
        this.videoBasicAdditionalCalculated = videoCost;
        totalCalculated += videoCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoBasicValidated = false;
      } else {
        this.videoBasicValidated = true;
      }

      this.videoBasicSelectedTotal = totalCalculated;

      return totalCalculated;
    },
    videoStandardCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { standard } = video || {}; 
      const { base, additional_videos } = standard || {};
      let totalCalculated = base;

      if(this.videoStandard48Hours !== null) {
        totalCalculated += parseFloat(this.videoStandard48Hours);
      }
      
      if(this.videoStandardOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoStandardOffendersLocation);
      }

      if(this.videoStandardAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoStandardAdditionalVideo) * additional_videos;
        this.videoStandardAdditionalCalculated = videoCost;
        totalCalculated += videoCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoStandardValidated = false;
      } else {
        this.videoStandardValidated = true;
      }

      this.videoStandardSelectedTotal = totalCalculated;

      return totalCalculated;
    },
    videoPremiumCalculate: function () {
      const { packages, maxPackageLimit } = this.$store.state;
      const { video } = packages || {}; 
      const { premium } = video || {}; 
      const { base, additional_videos } = premium || {};
      let totalCalculated = base;

      if(this.videoPremium48Hours !== null) {
        totalCalculated += parseFloat(this.videoPremium48Hours);
      }
      
      if(this.videoPremiumOffendersLocation !== null) {
        totalCalculated += parseFloat(this.videoPremiumOffendersLocation);
      }

      if(this.videoPremiumAdditionalVideo !== null) {
        const videoCost = parseFloat(this.videoPremiumAdditionalVideo) * additional_videos;
        this.videoPremiumAdditionalCalculated = videoCost;
        totalCalculated += videoCost;
      }

      if(totalCalculated > maxPackageLimit) {
        this.videoPremiumValidated = false;
      } else {
        this.videoPremiumValidated = true;
      }

      this.videoPremiumSelectedTotal = totalCalculated;

      return totalCalculated;
    }
  },
  methods: {
    onSelect: function (d) {
      console.log("e", d);
    },
    onChangeInputImagesVideos: function (e, index) {
      console.log("Eee", e);

      if(e.target.files && e.target.files.length > 0) {
        this.clientInputImagesVideos[index].file = e.target.files[0];
        this.clientInputImagesVideos[index].error = false;
      }
    },
    onChangeAdditionalInputImagesVideos: function (e, index) {
      console.log("Eee", e);

      if(e.target.files && e.target.files.length > 0) {
        this.imageVideosAdditionalFiles[index].file = e.target.files[0];
        this.imageVideosAdditionalFiles[index].error = false;
      }
    },
    updateImageStandardAdditionalImages: function (d) {
      console.log("e", d);
       if(this.imageStandardAdditionalImages !== null) {
        const imagesCount = parseFloat(this.imageStandardAdditionalImages);

        if(imagesCount == 0) {
          this.imageVideosAdditionalFiles = [];
          return;
        }

        const remainings = imagesCount - this.imageVideosAdditionalFiles.length;

        console.log("remainings", remainings);

        if(remainings == imagesCount) {
          this.imageVideosAdditionalFiles = [{file: ""}];
        } else if(remainings < 0) {
          for(let i = 0; i < Math.abs(remainings); i++) {
            this.imageVideosAdditionalFiles.pop();
          }
        }
      }
    },
    onChangePackages: function (d) {
      console.log("e", d);
      this.clientInputImagesVideos = [{file: ""}];
      this.imageVideosAdditionalFiles = [];
      this.imageStandardAdditionalImages = 0;
    },
    onAddClientAddExceptionalSources: function (d) {
      if(this.exceptionalSources == null) {
        this.exceptionalSources = [];
      }

      if(this.exceptionalSources.length == this.exceptionalSourcesLimit) {
        return;
      }

      this.exceptionalSources.push({file: ""});
    },
    onAddClientAdditionalInputImagesVideos: function (d) {
      const imagesCount = parseFloat(this.imageStandardAdditionalImages);

      if(this.imageVideosAdditionalFiles == null) {
        this.imageVideosAdditionalFiles = [];
      }

      const remainings = imagesCount - this.imageVideosAdditionalFiles.length;

      if(remainings == 0) {
        return;
      }

      this.imageVideosAdditionalFiles.push({file: ""});
    },
    onAddClientInputImagesVideos: function (d) {
      if(this.clientInputImagesVideos.length > this.packages[this.packageType][this.selectedPackage].base_images_limit) {
        return;
      }
      this.clientInputImagesVideos.push({file: ""});
    },
    onAddClientInputSignature: function (d) {
      if(this.clientInputSignature.length > this.clientInputSignatureLimit) {
        return;
      }
      this.clientInputSignature.push({file: ""});
    },
    onChangeClientInputLegalDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputLegalDocs[index].file = item.target.files[0];
      } else {
        this.clientInputLegalDocs[index].file = null;
      }
    },
    onChangeClientInputSignatureDocs: function (item, index) {
      if(item && item.target && item.target.files && Array.isArray(item.target.files)) {
        this.clientInputSignature[index].file = item.target.files[0];
      } else {
        this.clientInputSignature[index].file = null;
      }
    },
    onSelectCountry: function (d) {
      console.log("onSelectCountry:e", d);
      this.country = d.name;
    },
    submitRegistration: function (e) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const $this = this;
      this.emailRequiredError = false;
      this.ticketNumberRequiredError = false;
      this.emailError = false;

      let error = 0;

      console.log("this.clientInputImagesVideos", this.clientInputImagesVideos);

      for(let i = 0; i < this.clientInputImagesVideos.length; i++) {
        const element = this.clientInputImagesVideos[i];
        if(element.file == "") {
          this.clientInputImagesVideos[i].error = true;
          this.$set(this.clientInputImagesVideos, i, this.clientInputImagesVideos[i]);
          error += 1;
        } else {
          this.clientInputImagesVideos[i].error = false;
          this.$set(this.clientInputImagesVideos, i, this.clientInputImagesVideos[i]);
        }
      }
      
      for(let i = 0; i < this.imageVideosAdditionalFiles.length; i++) {
        const element = this.imageVideosAdditionalFiles[i];
        if(element.file == "") {
          this.imageVideosAdditionalFiles[i].error = true;
          this.$set(this.imageVideosAdditionalFiles, i, this.imageVideosAdditionalFiles[i]);
          error += 1;
        } else {
          this.imageVideosAdditionalFiles[i].error = false;
          this.$set(this.imageVideosAdditionalFiles, i, this.imageVideosAdditionalFiles[i]);
        }
      }

      console.log("this.clientInputImagesVideoserror", error);

      if(error > 0) {
        this.clientInputImagesVideos = this.clientInputImagesVideos;
        return;
      }

      jQuery
        .post("http://stagingportal.clearmeout.com/signup.php")
        .done(function (data) {
          console.log("data", data);
          $this.email = "";
          $this.ticketNumber = "";
          if (data.status == 500) {
            $this.$toast.open({
              message: data.status_message,
              type: "error",
            });
          }
        })
        .fail(function (data) {
          console.log("data", data);
          $this.$toast.open({
            message:
              "Invalid registration details. Please update and submit again.",
            type: "error",
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tick-row {
  display: inline-flex;
  background: #fff;
}

.tick-row input {
  margin-right: 10px !important;
}


</style>



// WEBPACK FOOTER //
// src/components/selectPackages.vue